// Generated by ReScript, PLEASE EDIT WITH CARE


function machine(state, action) {
  if (typeof state === "number") {
    switch (action.TAG | 0) {
      case /* FetchCustomerInfoSuccess */0 :
          return {
                  TAG: /* CustomerInfo */0,
                  _0: action._0,
                  _1: action._1
                };
      case /* FetchCustomerInfoFailed */1 :
          return {
                  TAG: /* Error */1,
                  _0: action._0
                };
      case /* UpdateCustomer */2 :
      case /* UpdateCustomerFailed */3 :
          return state;
      
    }
  } else {
    if (state.TAG !== /* CustomerInfo */0) {
      return state;
    }
    switch (action.TAG | 0) {
      case /* FetchCustomerInfoSuccess */0 :
      case /* FetchCustomerInfoFailed */1 :
          return state;
      case /* UpdateCustomer */2 :
          return {
                  TAG: /* CustomerInfo */0,
                  _0: action._0,
                  _1: state._1
                };
      case /* UpdateCustomerFailed */3 :
          return {
                  TAG: /* Error */1,
                  _0: action._0
                };
      
    }
  }
}

export {
  machine ,
  
}
/* No side effect */
